import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RentalOrder } from 'src/app/models/rental/rental-order';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HeaderFilters, HttpService, MenuBreadCrumb, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { ModalRentalOrderComponent } from './modal-rental-order/modal-rental-order.component';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { Router } from '@angular/router';

export enum stateTab {
  TABLE = 0,
  ADD = 1,
  EDIT = 2,
  DETAIL = 3,
}
@Component({
    selector: 'app-rental-order',
    templateUrl: './rental-order.component.html',
    styleUrls: ['./rental-order.component.scss'],
    standalone: false
})
export class RentalOrderComponent implements OnInit {

  public EndpointDictionary = EndpointDictionary;
  public stateTab = stateTab;
  public currentState: stateTab = stateTab.TABLE;

  public menuBreadCrumb:Array<MenuBreadCrumb>= [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Orden de Alquiler",
      current:true
    }
  ]

  public labels = []
  public selected = new FormControl(0);
  public detailsClickRow: RentalOrder

  // tabla orden compra
  public reloadTablaRO = new EventEmitter<any>();
  public configurationRO: TableConfiguration = {
    add: true,
    edit: true,
    selectable: screen.width> 600 ? true : false,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    hideTitle:true,
    exportXslx: true,
    advance: true,
    view:true,
    advanceLabel: 'Avanzar',
  };
  public columnsRO: TableColumns<RentalOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'number',
      style: {
        textAlign: 'center',
        width: '80px',
      },
    },
    {
      ID: 'providerName',
      label: 'Cliente',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'providerAddress',
      label: 'Dirección',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'userDeliveryName',
      label: 'Entrega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'userReceivesName',
      label: 'Recibe',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'stateName',
      label: 'Estado',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'startDate',
      label: 'Fecha Inicio',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'endDate',
      label: 'Fecha Fin',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
];

  headerFileXlsm:Array<params> = [
    {id:"consecutive", value:"Consecutivo"},
    {id:"providerName", value:"Cliente"},
    {id:"userDeliveryName", value:"Entrega"},
    {id:"userReceivesName", value:"Recibe"},
    {id:"stateName", value:"Estado"},
    {id:"comment", value:"Comentario"},
    {id:"startDate", value:"Fecha Inicio"},
    {id:"endDate", value:"Fecha Fin"},
  ]

  headerFilters: Array<HeaderFilters> = [
    {
      tN: "t",
      labelFilter:"Cliente",
      urlData: EndpointDictionary.Provider.PROVIDER_TYPE_COMBO + '/4',
      visibleField:"providerName",
      primaryKey:"id",
      type:"select",
      value:""
    },
    {
      tN: "ao",
      labelFilter:"Entrega",
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField:"name",
      primaryKey:"userId",
      type:"select",
      value:"",
      fileNameDb: "id_usuario_entrega"
    },
    {
      tN: "ao",
      labelFilter:"Recibe",
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField:"name",
      primaryKey:"userId",
      type:"select",
      value:"",
      fileNameDb: "id_usuario_recibe"
    },
    {
      tN: "eao",
      labelFilter:"Estado de Orden",
      urlData: EndpointDictionary.RentalOrder.STATE_RENTAL_ORDER_COMBO,
      visibleField:"state",
      primaryKey:"id",
      type:"select",
      value:"",
    },
    {
      tN: "ao",
      labelFilter:"Fecha Inicio",
      visibleField:"fecha_inicio",
      type:"date",
      value:""
    },
    {
      tN: "ao",
      labelFilter:"Fecha Fin",
      visibleField:"fecha_fin",
      type:"date",
      value:""
    },
    {
      tN: "ao",
      labelFilter:"Fecha Inicio Entre",
      visibleField:"fecha_inicio",
      type:"dateRange",
      value:""
    },
    {
      tN: "ao",
      labelFilter:"Fecha Fin Entre",
      visibleField:"fecha_fin",
      type:"dateRange",
      value:""
    }
  ]

  constructor(
    private http: HttpService,
    private session: SessionService,
    private dialog: MatDialog,
    private utils: UtilsServiceService,
    private router: Router,
    private message: MessageService

  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.session.setData('data', null)
  }


  addRO($event: RentalOrder) {
    this.session.setData('data', { action: 'add' })
    this.selected.setValue(1)
    this.currentState = stateTab.ADD
  }

  async editarRO($event: RentalOrder) {
    let res: Array<RentalOrder> = await this.http.getDataBody(`${EndpointDictionary.RentalOrder.CRUD_RENTAL_ORDER}/${$event[0].id}`)
    if (res) {
      this.selected.setValue(1)
      this.currentState = stateTab.EDIT
      this.session.setData('data', { action: 'edit', body: res })
    }
  }

  async viewDetail($event: RentalOrder[]) {
    this.selected.setValue(1)
    this.currentState = stateTab.DETAIL
    this.detailsClickRow = $event[0]
  }

  async advanceRO($event: RentalOrder[]) {
   if($event[0].stateId == 2 || $event[0].stateId == 3){
    this.dialog.open(ModalRentalOrderComponent, {
      width:'80%',
      data: { $event: $event[0] }
    }).afterClosed().subscribe(
      res => {
        this.reloadTablaRO.emit()
      }
    )
   }
   if ($event[0].stateId == 1) {
    let url = this.utils.getQueryParams(`/alquiler/despachos${'?orderId='+ $event[0].id}`);
    this.router.navigate([`${url.url}`], {
      queryParams: url.params,
    });
   }

   if ($event[0].stateId == 4) {
    let url = this.utils.getQueryParams(`/alquiler/ingresos${'?orderId='+ $event[0].id}`);
    this.router.navigate([`${url.url}`], {
      queryParams: url.params,
    });
   }

   if ($event[0].stateId == 5) {
    this.message.Warning('Advertencia', 'La orden de alquiler ya se encuentra finalizada')
   }


  }

  completeCreateOrder() {
    this.reloadTablaRO.emit()
    this.selected.setValue(0)
    this.currentState = stateTab.TABLE
  }

}
